import React, {FC} from 'react';

import {welcomeCarouselPersonaSlide} from '../../../carousel/welcome/welcomeCarouselPersonaSlide';
import {OnboardingGuideAnimatedStyles, OnboardingGuidePopover} from '../../guide/onboardingGuidePopover';

/*
 * Props.
 */

export interface FluGuidePopoverProps {
  styles: OnboardingGuideAnimatedStyles | undefined;
  onComplete: () => void;
  onClose: () => void;
}

/*
 * Component.
 */

export const FluGuidePopover: FC<FluGuidePopoverProps> = (props) => {
  const {onComplete, onClose, styles} = props;

  const {renderContent} = welcomeCarouselPersonaSlide;

  return (
    <OnboardingGuidePopover styles={styles} onRequestClose={onClose} width="800px" height="451px">
      {renderContent({
        index: 0,
        onPreviousClick: undefined,
        onNextClick: () => onComplete(),
      })}
    </OnboardingGuidePopover>
  );
};
